import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Spinner, Alert } from 'react-bootstrap';

function About() {
  const [pageContent, setPageContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const baseURL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    fetchPageContent();
  }, []);

  const fetchPageContent = async () => {
    try {
      const response = await fetch(`${baseURL}/pages.php?page=about`);
      if (response.ok) {
        const data = await response.json();
        setPageContent(data);
      } else {
        throw new Error('Failed to fetch page content');
      }
    } catch (err) {
      setError('Error loading page content. Please try again later.');
      console.error('Error fetching page content:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Container className="py-5 text-center">
        <Spinner animation="border" role="status" variant="primary">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
        <p className="mt-2">Loading content...</p>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="py-5">
        <Alert variant="danger">{error}</Alert>
      </Container>
    );
  }

  return (
    <Container className="py-5">
      {/* Dynamic Content from Admin */}
      {pageContent && (
        <Row className="mb-5">
          <Col>
            <h1 className="text-center royal-blue-text emerald-green-border mb-4">
              {pageContent.page_title || 'About Us'}
            </h1>
            <div 
              className="page-content"
              dangerouslySetInnerHTML={{ __html: pageContent.page_content }} 
            />
          </Col>
        </Row>
      )}

      {/* Static fallback content */}
      {!pageContent && (
        <Row className="mb-5">
          <Col>
            <h1 className="text-center royal-blue-text emerald-green-border mb-4">About Us</h1>
            <p className="lead text-center">
              Precision Analytical Lab Solutions East Africa Ltd is a trusted provider of high-quality 
              laboratory equipment and analytical solutions.
            </p>
            {/* Add your default about content here */}
          </Col>
        </Row>
      )}
    </Container>
  );
}

export default About;